import {
  ACTIVITY,
  AI_ANALYTICS,
  BSS,
  CALENDAR,
  CAS,
  CRA_REVIEW,
  DASHBOARDS,
  ENROLMENTS,
  EXTERNAL_INTEGRATION,
  FINANCE,
  HELP,
  INVOICE,
  ITEM_GROUP_TEMPLATES,
  LOAD_PATIENTS,
  PATIENT_BULK_UPDATE,
  PATIENT_DATABASE,
  PATIENT_SOURCE_MANAGEMENT,
  PATIENT_STIPEND_WORKLIST,
  PI_WORK_LIST,
  PL,
  PM_WORKBOOK,
  PRE_SCREEN,
  PROJECTED_REVENUE,
  PS,
  REIMBURSEMENT_WORKLIST,
  REVENUE,
  SAS,
  SBS,
  SCHEDULING_WORK_LIST,
  SITE_FINANCE,
  SITE_PAYMENTS,
  SM_WORKLIST,
  SS,
  ST,
  STD,
  STUDY_ENROLMENTS,
  STUDY_EXPENSES,
  TASK_WORK_LIST,
  TIMELINE,
  TRANSACTION_LEDGER,
  TRAVEL_REQUEST_WORKLIST,
  VAS,
  WORK_LIST
} from 'constants/accessToPages';

import { setDefaultFilterItemsToStorage } from './MenuOptionsService';

export const MenuItems = [
  {
    i18nKey: 'preScreen',
    access: PRE_SCREEN,
    subItems: [
      { i18nKey: 'loadPatients', access: LOAD_PATIENTS, path: '/load-patients' },
      { i18nKey: 'patientBulkUpdate', access: PATIENT_BULK_UPDATE, path: '/patient-bulk-update' },
      {
        i18nKey: 'patientDatabase',
        access: PATIENT_DATABASE,
        path: '/patient-database',
        feature: 'patientDatabaseEnabled'
      },
      { i18nKey: 'worklist', access: WORK_LIST, path: '/worklist' }
    ]
  },
  {
    i18nKey: 'patientSource',
    access: [PS, TASK_WORK_LIST],
    subItems: [
      { i18nKey: 'patients', access: PL, path: '/patients' },
      { i18nKey: 'craReview', access: CRA_REVIEW, path: '/patient-source-review' },
      { i18nKey: 'studyManagerWorklist', access: SM_WORKLIST, path: '/sm-work-list' },
      { i18nKey: 'investigatorWorklist', access: PI_WORK_LIST, path: '/pi-work-list' },
      { i18nKey: 'schedulingWorklist', access: SCHEDULING_WORK_LIST, path: '/scheduling-work-list' },
      { i18nKey: 'taskWorklist', access: TASK_WORK_LIST, path: '/task-work-list' },
      { i18nKey: 'pmWorkbook', access: PM_WORKBOOK, path: '/pm-workbook' }
    ]
  },
  {
    i18nKey: 'study',
    access: [ACTIVITY, TIMELINE, SS],
    subItems: [
      { i18nKey: 'studyDetails', access: SS, path: '/study-details', onClick: setDefaultFilterItemsToStorage },
      { i18nKey: 'timeline', access: TIMELINE, path: '/study-timeline', onClick: setDefaultFilterItemsToStorage },
      {
        i18nKey: 'enrollment',
        access: STUDY_ENROLMENTS,
        path: '/study-enrollment',
        onClick: setDefaultFilterItemsToStorage
      },
      {
        i18nKey: 'expenses',
        access: STUDY_EXPENSES,
        path: '/study-expenses',
        onClick: setDefaultFilterItemsToStorage
      }
    ]
  },
  {
    i18nKey: 'setup',
    access: ST,
    subItems: [
      { i18nKey: 'protocol', access: STD, path: '/study-protocol', onClick: setDefaultFilterItemsToStorage },
      {
        i18nKey: 'itemGroupTemplates',
        access: ITEM_GROUP_TEMPLATES,
        path: '/protocol-item-group-templates'
      },
      {
        i18nKey: 'budget',
        access: SBS,
        path: '/study-budget'
      },
      { i18nKey: 'publishBudget', access: BSS, path: '/publish-budget' },
      {
        i18nKey: 'accounts',
        access: [CAS, SAS, VAS],
        path: '/accounts'
      },
      {
        i18nKey: 'externalIntegration',
        access: EXTERNAL_INTEGRATION,
        path: '',
        subItems: [
          { i18nKey: 'platformConfiguration', access: EXTERNAL_INTEGRATION, path: '/platform-configuration' },
          { i18nKey: 'afterburnerMapping', access: EXTERNAL_INTEGRATION, path: '/afterburner-mapping' },
          { i18nKey: 'mappingTemplates', access: EXTERNAL_INTEGRATION, path: '/mapping-templates' },
          { i18nKey: 'afterburnerLog', access: EXTERNAL_INTEGRATION, path: '/afterburner-log' }
        ]
      },
      { i18nKey: 'patientSourceManagement', access: PATIENT_SOURCE_MANAGEMENT, path: '/patient-source-management' }
    ]
  },
  {
    i18nKey: 'finance',
    access: [FINANCE, SITE_FINANCE],
    subItems: [
      {
        i18nKey: 'ledger',
        access: TRANSACTION_LEDGER,
        path: '/transaction-ledger',
        onClick: setDefaultFilterItemsToStorage
      },
      { i18nKey: 'revenue', access: REVENUE, path: '/revenue', onClick: setDefaultFilterItemsToStorage },
      {
        i18nKey: 'invoice',
        access: INVOICE,
        path: '/invoice',
        onClick: setDefaultFilterItemsToStorage
      },
      { i18nKey: 'sitePayments', access: SITE_PAYMENTS, path: '/site-payments', feature: 'sitePaymentsEnabled' },
      { i18nKey: 'siteFinance', access: SITE_FINANCE, path: '/site-finance' },
      {
        i18nKey: 'reimbursements',
        access: REIMBURSEMENT_WORKLIST,
        path: '/reimbursements',
        onClick: setDefaultFilterItemsToStorage
      },
      { i18nKey: 'enrollment', access: ENROLMENTS, path: '/enrollments', onClick: setDefaultFilterItemsToStorage },
      {
        i18nKey: 'projectedRevenue',
        access: PROJECTED_REVENUE,
        path: '/projected-revenue',
        onClick: setDefaultFilterItemsToStorage
      },
      {
        i18nKey: 'travelRequests',
        access: TRAVEL_REQUEST_WORKLIST,
        path: '/travel-requests',
        onClick: setDefaultFilterItemsToStorage
      },
      {
        i18nKey: 'patientStipends',
        access: PATIENT_STIPEND_WORKLIST,
        path: '/patient-stipends',
        onClick: setDefaultFilterItemsToStorage
      }
    ]
  },
  {
    i18nKey: 'dashboards',
    access: DASHBOARDS,
    path: '/dashboards'
  },
  {
    i18nKey: 'aiAnalytics',
    access: AI_ANALYTICS,
    path: '/ai-analytics',
    feature: 'aiAnalyticsEnabled'
  },
  {
    i18nKey: 'calendar',
    path: '/calendar',
    access: CALENDAR
  },
  {
    i18nKey: 'help',
    path: '/help',
    access: HELP
  }
];
